import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { S3Service } from '../../services/s3/s3.service';
import { UtilityService } from '../../services/utility/utility.service';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification/notification.service';
import { NotificationType } from '../../models/notification-type';
import { BlobService } from '../../services/file/blob.service';
import * as FileSaver from 'file-saver';
import { ErrorHandlerService } from '../../services/error-handler/error-handler.service';

@Component({
  selector: 'upsc-s3-file-downloader',
  templateUrl: './s3-file-downloader.component.html',
  styleUrls: ['./s3-file-downloader.component.scss'],
})
export class S3FileDownloaderComponent implements OnInit, OnDestroy {
  @Input() public bucketName: string;
  @Input() public fileName: string;
  @Input() public buttonText = 'Download';
  @Input() public buttonClass = 'alternative-button';
  @Input() public buttonId = null;
  @Input() public showDownloadIcon = false;
  @Output() public fileDownloadEnded: EventEmitter<boolean> = new EventEmitter<boolean>();

  public isFileDownloading = false;
  private downloadFileSubscription: Subscription;

  constructor(private utilityService: UtilityService,
              private notificationService: NotificationService,
              private blobService: BlobService,
              private errorHandlerService: ErrorHandlerService,
              private s3Service: S3Service) {
  }

  public ngOnInit() {
  }

  public ngOnDestroy() {
    this.utilityService.clearSubscriptions([this.downloadFileSubscription]);
  }

  public downloadFile(event) {
    if (event) {
      event.preventDefault();

      if (event.target.type && event.target.type !== 'button') {
        // event.currentTarget contains the element that actually has the event listener.
        event.currentTarget.dispatchEvent(new MouseEvent('click'));
      }
    }

    this.isFileDownloading = true;
    this.utilityService.clearSubscriptions([this.downloadFileSubscription]);
    this.downloadFileSubscription = this.s3Service.getFile(this.bucketName, this.fileName)
      .subscribe(
        base64 => this.handleGetFileFromS3Success(base64),
        err => this.handleGetFileFromS3Failure(err),
      );
  }

  public downloadBucketFile(bucketName: string, fileName: string) {
    this.downloadFileSubscription = this.s3Service.getFile(bucketName, fileName)
      .subscribe(
        base64 => this.handleGetFileFromS3Success(base64),
        err => this.handleGetFileFromS3Failure(err),
      );
  } 

  private handleGetFileFromS3Success(base64: string) {
    this.isFileDownloading = false;
    const blob = this.blobService.base64PdfToBlob(base64);
    FileSaver.saveAs(blob, this.fileName);
    this.fileDownloadEnded.emit(true);
  }

  private handleGetFileFromS3Failure(err) {
    this.notificationService.notify(
      this.errorHandlerService.getHttpErrorMessage(err),
      'Failed Downloading File',
      NotificationType.ERROR);
    this.isFileDownloading = false;
    this.fileDownloadEnded.emit(true);
  }
}
